<template>
  <div class="d-flex justify-content-center">
    <button
      v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
      class="btn btn-danger btn-sm"
      @click.stop="$emit('delete', attribution)"
    >
      <i class="icon-close"></i>
    </button>
    <button
      class="btn btn-secondary btn-sm"
      :disabled="!hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
      @click.stop="$emit('details', attribution)"
    >
      <i class="icon-user"></i>
      {{ status }}

      <span v-if="accepted" class="text-success">
        <i class="icon-user-following"></i>
        {{ accepted }}
      </span>

      <span v-if="rejected" class="text-danger">
        <i class="icon-user-unfollow"></i>
        {{ rejected }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    attribution: {
      type: Object,
      required: true,
    },
  },

  computed: {
    status() {
      return this.attribution.coachs.length || "Aucun";
    },

    accepted() {
      return this.attribution.coachs.filter((c) => c.accepted).length;
    },

    rejected() {
      return this.attribution.coachs.filter((c) => c.rejected).length;
    },
  },
};
</script>
